import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {GGChip} from './GGChip'

export const GGChipGroup = ({
  options,
  multiselect = false,
  name = 'chips',
  value,
  onChange,
  className = '',
  disabledOptions = [],
}) => {

  const [ internal, setInternal ] = useState(multiselect ? [] : null)
  const selected = value !== undefined ? value : internal
  const setSelected = onChange || setInternal

  const handleClick = (val) => {
    if (multiselect) {
      const arr = Array.isArray(selected) ? selected : []
      const next = arr.includes(val) ? arr.filter(v => v !== val) : [ ...arr, val ]
      setSelected(next)
    } else {
      setSelected(val)
    }
  }

  const isSelected = (val) =>
    multiselect ? (Array.isArray(selected) && selected.includes(val)) : selected === val

  return (
    <div className={[ 'gg-chip-group', className ].filter(Boolean).join(' ')}>
      {options.map(opt => (
        <GGChip
          key={opt.value}
          label={opt.label}
          value={opt.value}
          name={name}
          selected={isSelected(opt.value)}
          onClick={() => handleClick(opt.value)}
          multiselect={multiselect}
          disabled={disabledOptions.includes(opt.value)}
        />
      ))}
    </div>
  )
}

GGChipGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  name: PropTypes.string,
  multiselect: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabledOptions: PropTypes.arrayOf(PropTypes.string),
}
